import { Grid, Typography } from '@mui/material';
import { convertToRaw, Editor, EditorState } from 'draft-js';
import React from 'react';
import { RichEditor } from '../RichEditor';
import draftToHtml from 'draftjs-to-html';
import { createStateFromHtml } from '../../utils/draft-js';

type Props = {
  initData?: {
    content_vi?: string;
    content_en?: string;
  };
};

type States = {
  contentViState: EditorState;
  contentEnState: EditorState;
};

export class ContentEditor extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = Object.freeze({
      contentViState: EditorState.createEmpty(),
      contentEnState: EditorState.createEmpty(),
    });
  }

  componentDidMount() {
    if (this.props.initData) {
      this.updateContentStates(this.props.initData);
    }
  }

  updateContentStates = (data: {
    content_vi?: string;
    content_en?: string;
  }) => {
    this.setState({
      contentViState: createStateFromHtml(data.content_vi || ''),
      contentEnState: createStateFromHtml(data.content_en || ''),
    });
  };

  getContentData = () => {
    return {
      content_vi: this.getHTMLContent(this.state.contentViState),
      content_en: this.getHTMLContent(this.state.contentEnState),
    };
  };

  private getHTMLContent = (editorState: EditorState): string => {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  };

  private handleContentViChange = (contentViState: EditorState) => {
    this.setState({ contentViState });
  };

  private handleContentEnChange = (contentEnState: EditorState) => {
    this.setState({ contentEnState });
  };

  render(): React.ReactNode {
    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h5" p={1}>
            Content
          </Typography>
        </Grid>
        <Grid item xs={12} xl={6}>
          <Typography p={1} mb={1}>
            Vietnamese
          </Typography>

          <RichEditor
            contentState={this.state.contentViState}
            onEditorStateChange={this.handleContentViChange}
          />
        </Grid>
        <Grid item xs={12} xl={6}>
          <Typography p={1} mb={1}>
            English
          </Typography>
          <RichEditor
            contentState={this.state.contentEnState}
            onEditorStateChange={this.handleContentEnChange}
          />
        </Grid>
      </>
    );
  }
}
